<app-pias-layout>
  <div pias-layout-content>
    @if (this.setSprinner()) {
    <div class="pias-spinner">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    }
    <br />
    <div class="page-header-section">
      <div class="page-header-left">
        <div class="title-container">
          <h4 class="page-title">Annual Declaration</h4>

          <div class="status-chip-box">
            <span class="status-label">Current Status:</span>

            @if (workflowStatus) {
            <span class="status-badge-header" [ngClass]="{
                  'status-approved': workflowStatus === 'APPROVED',
                  'status-inreview': workflowStatus === 'IN_REVIEW',
                  'status-returned': workflowStatus === 'RETURNED',
                  'status-success': workflowStatus === 'SUBMITTED',
                  'status-warning': workflowStatus === 'IN_PROGRESS',
                  'status-secondary': workflowStatus === 'NOT_STARTED',
                }">
              {{ workflowStatus.replace('_', ' ') }}
            </span>
            } @else {
            <span class="status-badge status-loading">Loading...</span>
            }
          </div>
        </div>

        <!-- <p class="page-subtitle">
      Manage annual declaration workflow, review progress, and check submission status.
    </p> -->
      </div>
    </div>
    <br />
    <!-- <p>Mode: {{ loggedInRole }}</p> -->
    <form [formGroup]="formGroup">
      <mat-accordion>
        <!-- <h5 class="field-title">Required Documents</h5> -->
        <!-- <div class="ads-container">
          <ol>
            <li>
              Application pack is valid for 3 months from the date the application form is signed.
            </li>
            <li>Certified True Copy NRIC or Passport & Proof of Address.</li>
            <li>Bank Account Statement (within last 3 months).</li>
            <li>
              Proof of employment (e.g. Latest 6 months CPF Contributions statement or latest 3
              months payslips, or latest 1 month employment acknowledgment letter (signed & stamped)
              from employer).
            </li>
          </ol>
        </div> -->
        <!-- Personal Particulars -->
        <mat-expansion-panel formGroupName="personalInfo" [expanded]="this.currentStep === 0">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(0)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">person</mat-icon>
              Personal Particulars
            </mat-panel-title>
            @if (this.personalDetailsFormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.personalDetailsFormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            } @else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>
          <!-- <h5 class="field-title">Information on New Representative</h5> -->
          <!-- <div class="bdm-container container-fluid"> -->
          <div class="row g-3">
            <!-- Full Name -->
            <div class="col-md-6">
              <mat-label class="field-label">Full Name as in NRIC</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="fullName" placeholder="Enter Name as in NRIC" required />
                @if (
                this.formGroup.get('personalInfo.fullName')?.invalid &&
                (this.formGroup.get('personalInfo.fullName')?.touched ||
                this.formGroup.get('personalInfo.fullName')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('personalInfo.fullName')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- MAS Representative No -->
            <div class="col-md-6">
              <mat-label class="field-label">MAS Representative No</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="representative_no" placeholder="Enter MAS Representative No "
                  required />
                @if (
                this.formGroup.get('personalInfo.representative_no')?.invalid &&
                (this.formGroup.get('personalInfo.representative_no')?.touched ||
                this.formGroup.get('personalInfo.representative_no')?.dirty)
                ) {
                <mat-error>
                  @if (
                  this.formGroup.get('personalInfo.representative_no')?.errors?.['required']
                  ) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Branch -->
            <div class="col-md-6">
              <mat-label class="field-label">Branch</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="branch" placeholder="Enter Branch" required />
                @if (
                this.formGroup.get('personalInfo.branch')?.invalid &&
                (this.formGroup.get('personalInfo.branch')?.touched ||
                this.formGroup.get('personalInfo.branch')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('personalInfo.branch')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Pias Rep Code -->
            <div class="col-md-6">
              <mat-label class="field-label">PIAS Rep Code</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="repcode" placeholder="Enter Pias Rep Code " required />
                @if (
                this.formGroup.get('personalInfo.repcode')?.invalid &&
                (this.formGroup.get('personalInfo.repcode')?.touched ||
                this.formGroup.get('personalInfo.repcode')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('personalInfo.repcode')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- NRIC -->
            <div class="col-md-6">
              <mat-label class="field-label">NRIC No.</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="nric" placeholder="Enter NRIC No." />
                @if (
                this.formGroup.get('personalInfo.nric')?.invalid &&
                (this.formGroup.get('personalInfo.nric')?.touched ||
                this.formGroup.get('personalInfo.nric')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('personalInfo.nric')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Nationality Section -->
          <div class="section-card mt-4">
            <h3 class="field-label">
              <!-- <mat-icon>flag</mat-icon> -->
              Nationality
            </h3>

            <mat-radio-group formControlName="nationality" class="d-flex flex-wrap gap-3 mb-3" required>
              <mat-radio-button value="Singapore Citizen">Singapore Citizen</mat-radio-button>
              <mat-radio-button value="Singapore Permanent Resident">Singapore Permanent Resident</mat-radio-button>
              <mat-radio-button value="others">Others</mat-radio-button>
            </mat-radio-group>
            @if (
            this.formGroup.get('personalInfo.nationality')?.invalid &&
            (this.formGroup.get('personalInfo.nationality')?.touched ||
            this.formGroup.get('personalInfo.nationality')?.dirty)
            ) {
            <mat-error>
              @if (this.formGroup.get('personalInfo.nationality')?.errors?.['required']) {
              <span>{{ message }}</span>
              } @else {
              <span></span>
              }
            </mat-error>
            }

            <!-- @if (
              this.formGroup.get('personalInfo.nationality')?.value ===
                'Singapore Permanent Resident' ||
              this.formGroup.get('personalInfo.nationality')?.value === 'others'
            ) { -->
            <p class="note">For Singapore Permanent Resident & Others, please state:</p>
            <div class="row g-3">
              <div class="col-md-6">
                <mat-label class="field-label">Nationality</mat-label>
                <mat-form-field class="w-100">
                  <mat-select formControlName="otherNationality" placeholder="Select Nationality" required>
                    @for (nationality of this.nationalities; track nationality) {
                    <mat-option value="{{ nationality.value }}">{{
                      nationality.name
                      }}</mat-option>
                    }
                  </mat-select>
                  @if (
                  this.formGroup.get('personalInfo.otherNationality')?.invalid &&
                  (this.formGroup.get('personalInfo.otherNationality')?.touched ||
                  this.formGroup.get('personalInfo.otherNationality')?.dirty)
                  ) {
                  <mat-error>
                    @if (
                    this.formGroup.get('personalInfo.otherNationality')?.errors?.['required']
                    ) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Country Of Birth -->
              <div class="col-md-6">
                <mat-label class="field-label">Country Of Birth</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="countryofbirth" placeholder="Enter Country Of Birth " required />
                  @if (
                  this.formGroup.get('personalInfo.Countryofbirth')?.invalid &&
                  (this.formGroup.get('personalInfo.Countryofbirth')?.touched ||
                  this.formGroup.get('personalInfo.Countryofbirth')?.dirty)
                  ) {
                  <mat-error>
                    @if (
                    this.formGroup.get('personalInfo.Countryofbirth')?.errors?.['required']
                    ) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- FIN No -->
              <div class="col-md-6">
                <mat-label class="field-label">FIN or Passport No</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="fin_No" placeholder="Enter FIN or Passport No" required />
                  @if (
                  this.formGroup.get('personalInfo.fin_No')?.invalid &&
                  (this.formGroup.get('personalInfo.fin_No')?.touched ||
                  this.formGroup.get('personalInfo.fin_No')?.dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.get('personalInfo.fin_No')?.errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <!-- } -->
          </div>
          <div class="row g-3">
            <!-- Email Address -->
            <div class="col-md-6">
              <mat-label class="field-label">Personal Email Address</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="email" placeholder="Enter Personal Email Address:" required />
                @if (
                this.formGroup.get('personalInfo.email')?.invalid &&
                (this.formGroup.get('personalInfo.email')?.touched ||
                this.formGroup.get('personalInfo.email')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('personalInfo.email')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Race Section -->
            <div class="section-card mt-4">
              <h3 class="field-label">
                <!-- <mat-icon>supervisor_account</mat-icon> -->
                Race
              </h3>

              <div class="row">
                <div class="col-md-12">
                  <mat-radio-group formControlName="race" class="d-flex flex-wrap gap-3" required>
                    <mat-radio-button value="chinese">Chinese</mat-radio-button>
                    <mat-radio-button value="malay">Malay</mat-radio-button>
                    <mat-radio-button value="indian">Indian</mat-radio-button>
                    <mat-radio-button value="others">Others</mat-radio-button>
                  </mat-radio-group>
                  @if (
                  this.formGroup.get('personalInfo.race')?.invalid &&
                  (this.formGroup.get('personalInfo.race')?.touched ||
                  this.formGroup.get('personalInfo.race')?.dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.get('personalInfo.race')?.errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </div>

                @if (formGroup.get('personalInfo.race')?.value === 'others') {
                <div class="col-md-6 mt-3">
                  <mat-label class="field-label">Specify Race</mat-label>
                  <mat-form-field class="w-100">
                    <input matInput formControlName="raceSpecify" placeholder="Please specify" />
                  </mat-form-field>
                </div>
                }
              </div>
            </div>

            <!-- Marital Status -->
            <div class="section-card mt-4">
              <h3 class="field-label">
                <!-- <mat-icon>favorite</mat-icon> -->
                Marital Status
              </h3>

              <mat-radio-group formControlName="maritalStatus" class="d-flex flex-wrap gap-3" required
                (change)="handleMartialChanges($event.value)">
                <mat-radio-button value="single">Single</mat-radio-button>
                <mat-radio-button value="Married">Married</mat-radio-button>
                <mat-radio-button value="widowed">Widowed</mat-radio-button>
                <mat-radio-button value="divorced">Divorced</mat-radio-button>
              </mat-radio-group>
              @if (
              this.formGroup.get('personalInfo.maritalStatus')?.invalid &&
              (this.formGroup.get('personalInfo.maritalStatus')?.touched ||
              this.formGroup.get('personalInfo.maritalStatus')?.dirty)
              ) {
              <mat-error>
                @if (this.formGroup.get('personalInfo.maritalStatus')?.errors?.['required']) {
                <span>{{ message }}</span>
                } @else {
                <span></span>
                }
              </mat-error>
              }
            </div>

            <!-- Residential Address -->
            <div class="col-md-6">
              <mat-label class="field-label">Residential Address</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="address" placeholder="Enter Residential Address" required />
                @if (
                this.formGroup.get('personalInfo.address')?.invalid &&
                (this.formGroup.get('personalInfo.address')?.touched ||
                showValidationErrors ||
                this.formGroup.get('personalInfo.address')?.dirty)
                ) {
                <mat-error>
                  @if (formGroup.get('personalInfo.address')?.hasError('required')) {
                  <span>{{ message }}</span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Contact Number -->
            <p class="field-label">Contact Number</p>
            <div class="col-md-6">
              <mat-label class="field-label">Home Number</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput type="text" formControlName="homenumber" maxlength="13" pattern="^\+?[0-9]+$"
                  onkeypress="
                    return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 43;
                  " placeholder="Enter Home Number" />
                @if (
                this.formGroup.get('personalInfo.homenumber')?.invalid &&
                (this.formGroup.get('personalInfo.homenumber')?.touched ||
                showValidationErrors ||
                this.formGroup.get('personalInfo.homenumber')?.dirty)
                ) {
                <mat-error>
                  @if (formGroup.get('personalInfo.homenumber')?.hasError('required')) {
                  <span>{{ message }}</span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-label class="field-label">Mobile Number</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput type="text" maxlength="13" pattern="^\+?[0-9]+$" onkeypress="
                    return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 43;
                  " formControlName="mobilenumber" placeholder="Enter Mobile Number" />
                @if (
                this.formGroup.get('personalInfo.mobilenumber')?.invalid &&
                (this.formGroup.get('personalInfo.mobilenumber')?.touched ||
                showValidationErrors ||
                this.formGroup.get('personalInfo.mobilenumber')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('personalInfo.mobilenumber')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
            <p class="note">
                <strong>Notes</strong><br>
              Personal particulars displayed are for reference and information only. Any changes or updates for this will need to be submitted separately to DSU. You may proceed with the Annual Declaration as presented.
            </p>
          </div>

          @if (readonly() === false) {
          <!-- Form Actions -->
          <div class="form-actions mt-4 text-end">
            <!-- [disabled]="formGroup.invalid" -->
            @if (
            this.personalDetailsFormValid() === 'In Progress' ||
            this.personalDetailsFormValid() === 'Not Started'
            ) {
            <!-- <button class="save-btn" (click)="saveAndContinue('personalInfo')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button> -->
            }
          </div>
          }
        </mat-expansion-panel>

        <!-- Spouse Details -->
        <mat-expansion-panel formGroupName="spouseInfo" [expanded]="this.currentStep === 1">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(1)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">wc</mat-icon>
              Spouse Details
            </mat-panel-title>
            @if (this.spouseDetailsFormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.spouseDetailsFormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            } @else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>
          <div class="row g-3">
            <!-- Spouse Name as in NRIC -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse Name as in NRIC {{ this.validator }}</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spousename" placeholder="Enter Spouse Name as in NRIC" required />
                @if (
                this.formGroup.get('spouseInfo.spousename')?.invalid &&
                (this.formGroup.get('spouseInfo.spousename')?.touched ||
                this.formGroup.get('spouseInfo.spousename')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('spouseInfo.spousename')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Spouse NRIC No. -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse NRIC No {{ this.validator }}</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spouse_no" placeholder="Enter Spouse NRIC No" />
                @if (
                this.formGroup.get('spouseInfo.spouse_no')?.invalid &&
                (this.formGroup.get('spouseInfo.spouse_no')?.touched ||
                this.formGroup.get('spouseInfo.spouse_no')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('spouseInfo.spouse_no')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- spouse_dob -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse Date of Birth {{ this.validator }}</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input formControlName="spouse_dob" matInput [matDatepicker]="picker" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                @if (
                this.formGroup.get('spouseInfo.spouse_dob')?.invalid &&
                (this.formGroup.get('spouseInfo.spouse_dob')?.touched ||
                this.formGroup.get('spouseInfo.spouse_dob')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('spouseInfo.spouse_dob')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Spouse Occupation & Name of Employer -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse Occupation {{ this.validator }}</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spouse_occupation"
                  placeholder="Enter Spouse Occupation & Name of Employer" />
                @if (
                this.formGroup.get('spouseInfo.spouse_occupation')?.invalid &&
                (this.formGroup.get('spouseInfo.spouse_occupation')?.touched ||
                this.formGroup.get('spouseInfo.spouse_occupation')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('spouseInfo.spouse_occupation')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!--  Name of Employer -->
            <div class="col-md-6">
              <mat-label class="field-label">Name of Employer {{ this.validator }}</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spouse_employer" placeholder="Enter Name of Employer" />
                @if (
                this.formGroup.get('spouseInfo.spouse_employer')?.invalid &&
                (this.formGroup.get('spouseInfo.spouse_employer')?.touched ||
                this.formGroup.get('spouseInfo.spouse_employer')?.dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.get('spouseInfo.spouse_employer')?.errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          @if (readonly() === false) {
          <!-- Form Actions -->
          <div class="form-actions mt-4 text-end">
            <!-- [disabled]="formGroup.invalid" -->
            @if (
            this.spouseDetailsFormValid() === 'In Progress' ||
            this.spouseDetailsFormValid() === 'Not Started'
            ) {
            <button class="save-btn" (click)="saveAndContinue('spouseInfo')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>
          }
        </mat-expansion-panel>

        <!-- Business Interests and Shareholdings/ Ownership -->
        <mat-expansion-panel formGroupName="questionnaire1" [expanded]="this.currentStep === 2">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(2)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon"> add_chart </mat-icon>

              Business Interests and Shareholdings/ Ownership
            </mat-panel-title>
            @if (this.questionnaire1FormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.questionnaire1FormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            }@else if (this.questionnaire1FormValid() === 'Verified') {
            <span class="status-badge verified m-4">
              <mat-icon>verified_user</mat-icon>
              Verified
            </span>
            }@else if (this.questionnaire1FormValid() === 'Action Required') {
            <span class="status-badge actionrequired m-4">
              <mat-icon>pending_actions</mat-icon>
              Action Required
            </span>
            } @else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>
          <div class="check-list">
            <ol class="custom-list">
              @for (q of questionnaire1Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire1', q.id)?.get('isVerified')?.value}">
                <div class="row">
                  <!-- QUESTION -->
                  <div class="col-sm-10">
                    <span>
                      {{ q.question }}
                    </span>
                    <p *ngIf="q.note" class="note">{{ q.note }}</p>
                    @if (getQuestionGroup('questionnaire1', q.id)?.get('isVerified')?.value === false &&
                    this.workflowStatus == 'RETURNED') {
                    <p class="delta-badge">
                      <mat-icon class="delta-icon">pending_actions</mat-icon> Action Required
                    </p>
                    }
                  </div>

                  <!-- YES / NO -->
                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>

                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- CONDITIONAL -->
                  @if (getQuestionGroup('questionnaire1', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3">
                    <mat-label>
                      {{ q.inputLabel }}
                    </mat-label>

                    <div class="row">
                      <!-- ENTITY -->
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" maxlength="1000" placeholder="Enter text here" />
                          @if (
                          (getQuestionGroup('questionnaire1', q.id)
                          ?.get('entityCount')
                          ?.hasError('required') &&
                          getQuestionGroup('questionnaire1', q.id)?.get('entityCount')
                          ?.touched) ||
                          showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>

                      <!-- ATTACHMENT -->
                      @if (q.hasAttachment) {
                      @let fileControl =
                      getQuestionGroup('questionnaire1', q.id)?.get('attachment.fileName');

                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box" [class.disabled-upload]="
                                    getQuestionGroup('questionnaire1', q.id)?.get('attachment')
                                      ?.disabled
                                  ">
                            @if (!fileControl?.value) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput [disabled]="
                                          getQuestionGroup('questionnaire1', q.id)?.get(
                                            'noAttachment'
                                          )?.value
                                        " (change)="onFileChange($event, 'questionnaire1', q.id)"
                                (blur)="fileControl?.markAsTouched()" />
                              <span> Choose file </span>
                            </label>
                            }

                            @if (fileControl?.value) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>
                                <span class="file-name">
                                  {{ fileControl?.value }}
                                </span>
                              </div>

                              @if (
                              ['RETURNED','IN_PROGRESS', 'NOT_STARTED'].includes(workflowStatus) &&
                              !getQuestionGroup('questionnaire1', q.id)?.get('attachment')
                              ?.disabled
                              ) {
                              <button mat-icon-button type="button" class="remove-btn" color="warn"
                                (click)="removeFile('questionnaire1', q.id)">
                                <mat-icon> close </mat-icon>
                              </button>
                              }
                            </div>
                            }
                          </div>
                          @if (
                          getQuestionGroup('questionnaire1', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileType')
                          ) {
                          <mat-error> Only PDF, JPEG and PNG files are allowed. </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire1', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileSize')
                          ) {
                          <mat-error> Maximum file size allowed is 5 MB. </mat-error>
                          }
                          @if (
                          getQuestionGroup('questionnaire1', q.id)?.hasError(
                          'attachmentMissing'
                          ) &&
                          !getQuestionGroup('questionnaire1', q.id)?.get('noAttachment')
                          ?.value &&
                          getQuestionGroup('questionnaire1', q.id)?.touched
                          ) {
                          <mat-error> This field is required </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire1', q.id)
                          ?.get('attachment')
                          ?.hasError('uploadFailed')
                          ) {
                          <mat-error> File upload failed. Please try again. </mat-error>
                          }
                        </div>
                      </div>
                      }

                      <!-- NO ATTACHMENT -->
                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment" [disabled]="hasAttachment('questionnaire1', q.id)">
                          No Attachment
                        </mat-checkbox>
                      </div>

                      <!-- REASON -->
                      @if (
                      getQuestionGroup('questionnaire1', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason" maxlength="1000" placeholder="Enter reason">
                                </textarea>
                          @if (
                          getQuestionGroup('questionnaire1', q.id)?.get(
                          'noAttachmentReason'
                          )?.touched || showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (workflowStatus === 'RETURNED') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes (<span class="font-bold">To be updated by
                          Adviser</span> - If any)</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000" ></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <!-- Form Actions -->
          <div class="form-actions mt-4 text-end">
            <!-- [disabled]="formGroup.invalid" -->
            @if (
            this.questionnaire1FormValid() === 'In Progress' ||
            this.questionnaire1FormValid() === 'Not Started'
            ) {
            <button class="save-btn" (click)="saveAndContinue('questionnaire1')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>

        </mat-expansion-panel>

        <!-- General Information -->
        <mat-expansion-panel formGroupName="questionnaire2" [expanded]="this.currentStep === 3">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(3)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">info</mat-icon>
              General Information
            </mat-panel-title>
            @if (this.questionnaire2FormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.questionnaire2FormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            } @else if (this.questionnaire2FormValid() === 'Verified') {
            <span class="status-badge verified m-4">
              <mat-icon>verified_user</mat-icon>
              Verified
            </span>
            }@else if (this.questionnaire2FormValid() === 'Action Required') {
            <span class="status-badge actionrequired m-4">
              <mat-icon>pending_actions</mat-icon>
              Action Required
            </span>
            }@else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>
          <div class="check-list">
            <ol class="custom-list">
              @for (q of questionnaire2Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire2', q.id)?.get('isVerified')?.value}">
                <div class="row">
                  <!-- QUESTION -->
                  <div class="col-sm-10">
                    <span>
                      {{ q.question }}
                    </span>
                    @if (getQuestionGroup('questionnaire2', q.id)?.get('isVerified')?.value === false &&
                    this.workflowStatus == 'RETURNED') {
                    <p class="delta-badge">
                      <mat-icon class="delta-icon">pending_actions</mat-icon> Action Required
                    </p>
                    }
                  </div>

                  <!-- YES / NO -->
                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>

                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- CONDITIONAL -->
                  @if (
                  getQuestionGroup('questionnaire2', q.id)?.get('answer')?.value &&
                  (q.inputLabel || q.hasAttachment)
                  ) {
                  <div class="col-12 mt-3">
                    @if (q.inputLabel) {
                    <mat-label>
                      {{ q.inputLabel }}
                    </mat-label>
                    }

                    <div class="row">
                      <!-- ENTITY -->
                      @if (q.inputLabel) {
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" maxlength="1000" placeholder="Enter text here" />
                          @if (
                          (getQuestionGroup('questionnaire2', q.id)
                          ?.get('entityCount')
                          ?.hasError('required') &&
                          getQuestionGroup('questionnaire2', q.id)?.get('entityCount')
                          ?.touched) ||
                          showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      }

                      <!-- ATTACHMENT -->
                      @if (q.hasAttachment) {
                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box" [class.disabled-upload]="
                                    getQuestionGroup('questionnaire2', q.id)?.get('attachment')
                                      ?.disabled
                                  ">
                            <!-- EMPTY -->
                            @if (
                            !getQuestionGroup('questionnaire2', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput [disabled]="
                                          getQuestionGroup('questionnaire2', q.id)?.get(
                                            'noAttachment'
                                          )?.value
                                        " (change)="onFileChange($event, 'questionnaire2', q.id)" />

                              <span> Choose file </span>
                            </label>
                            }

                            <!-- FILE SELECTED -->
                            @if (
                            getQuestionGroup('questionnaire2', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>

                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire2', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>

                              <!-- REMOVE -->
                              @if (
                              ['RETURNED','IN_PROGRESS', 'NOT_STARTED'].includes(workflowStatus) &&
                              !getQuestionGroup('questionnaire2', q.id)?.get('attachment')
                              ?.disabled
                              ) {
                              <button mat-icon-button type="button" class="remove-btn" color="warn"
                                (click)="removeFile('questionnaire2', q.id)">
                                <mat-icon> close </mat-icon>
                              </button>
                              }
                            </div>
                            }
                          </div>
                          @if (
                          getQuestionGroup('questionnaire2', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileType')
                          ) {
                          <mat-error> Only PDF, JPEG and PNG files are allowed. </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire2', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileSize')
                          ) {
                          <mat-error> Maximum file size allowed is 5 MB. </mat-error>
                          }
                          @if (
                          getQuestionGroup('questionnaire2', q.id)?.hasError(
                          'attachmentMissing'
                          ) &&
                          !getQuestionGroup('questionnaire2', q.id)?.get('noAttachment')
                          ?.value &&
                          getQuestionGroup('questionnaire2', q.id)?.touched
                          ) {
                          <mat-error> This field is required </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire2', q.id)
                          ?.get('attachment')
                          ?.hasError('uploadFailed')
                          ) {
                          <mat-error> File upload failed. Please try again. </mat-error>
                          }
                        </div>
                      </div>

                      <!-- NO ATTACHMENT -->
                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment" [disabled]="hasAttachment('questionnaire2', q.id)">
                          No Attachment
                        </mat-checkbox>
                      </div>
                      }

                      <!-- REASON -->
                      @if (
                      getQuestionGroup('questionnaire2', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason" maxlength="1000" placeholder="Enter reason">
                                </textarea>
                          @if (
                          getQuestionGroup('questionnaire2', q.id)?.get(
                          'noAttachmentReason'
                          )?.touched || showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (workflowStatus === 'RETURNED') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes (<span class="font-bold">To be updated by
                          Adviser</span> - If any)</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <!-- Form Actions -->
          <div class="form-actions mt-4 text-end">
            <!-- [disabled]="formGroup.invalid" -->
            @if (
            this.questionnaire2FormValid() === 'In Progress' ||
            this.questionnaire2FormValid() === 'Not Started'
            ) {
            <button class="save-btn" (click)="saveAndContinue('questionnaire2')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>

        </mat-expansion-panel>

        <!-- Fit and Proper Criteria -->
        <mat-expansion-panel formGroupName="questionnaire3" [expanded]="this.currentStep === 4">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(4)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">verified_user</mat-icon>
              Fit and Proper Criteria
            </mat-panel-title>
            @if (this.questionnaire3FormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.questionnaire3FormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            }@else if (this.questionnaire3FormValid() === 'Verified') {
            <span class="status-badge verified m-4">
              <mat-icon>verified_user</mat-icon>
              Verified
            </span>
            }@else if (this.questionnaire3FormValid() === 'Action Required') {
            <span class="status-badge actionrequired m-4">
              <mat-icon>pending_actions</mat-icon>
              Action Required
            </span>
            }
            @else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>

          <div class="check-list">
            <ol class="custom-list">
              @for (q of questionnaire3Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire3', q.id)?.get('isVerified')?.value}">
                <div class="row">
                  <div class="col-sm-10">
                    <div class="d-flex align-items-center gap-2">
                      <span class="question-text">{{ q.question }}</span>
                      @if (getQuestionGroup('questionnaire3', q.id)?.get('isVerified')?.value === false &&
                      this.workflowStatus == 'RETURNED') {
                      <p class="delta-badge">
                        <mat-icon class="delta-icon">pending_actions</mat-icon> Action Required
                      </p>
                      }
                    </div>

                    @if (q.description) {
                    <div class="text-muted mt-2 note" style="font-size: 0.85em; white-space: pre-wrap">
                      {{ q.description }}
                    </div>
                    }
                  </div>

                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>
                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  @if (getQuestionGroup('questionnaire3', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3 user-inputs">
                    @if (q.inputLabel) {
                    <mat-label>{{ q.inputLabel }}</mat-label>
                    }

                    <div class="row">
                      @if (q.inputLabel) {
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" maxlength="1000" placeholder="Enter text here" />
                          @if (
                          (getQuestionGroup('questionnaire3', q.id)
                          ?.get('entityCount')
                          ?.hasError('required') &&
                          getQuestionGroup('questionnaire3', q.id)?.get('entityCount')
                          ?.touched) ||
                          showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      }

                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box" [class.disabled-upload]="
                                  getQuestionGroup('questionnaire3', q.id)?.get('attachment')
                                    ?.disabled
                                ">
                            @if (
                            !getQuestionGroup('questionnaire3', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput [disabled]="
                                        getQuestionGroup('questionnaire3', q.id)?.get(
                                          'noAttachment'
                                        )?.value
                                      " (change)="onFileChange($event, 'questionnaire3', q.id)" />
                              <span> Choose file </span>
                            </label>
                            }

                            @if (
                            getQuestionGroup('questionnaire3', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>
                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire3', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>

                              <!-- REMOVE -->
                              @if (
                              ['RETURNED','IN_PROGRESS', 'NOT_STARTED'].includes(workflowStatus) &&
                              !getQuestionGroup('questionnaire3', q.id)?.get('attachment')
                              ?.disabled
                              ) {
                              <button mat-icon-button type="button" class="remove-btn" color="warn"
                                (click)="removeFile('questionnaire3', q.id)">
                                <mat-icon> close </mat-icon>
                              </button>
                              }
                            </div>
                            }
                          </div>
                          @if (
                          getQuestionGroup('questionnaire3', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileType')
                          ) {
                          <mat-error> Only PDF, JPEG and PNG files are allowed. </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire3', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileSize')
                          ) {
                          <mat-error> Maximum file size allowed is 5 MB. </mat-error>
                          }
                          @if (
                          getQuestionGroup('questionnaire3', q.id)?.hasError(
                          'attachmentMissing'
                          ) &&
                          !getQuestionGroup('questionnaire3', q.id)?.get('noAttachment')
                          ?.value &&
                          getQuestionGroup('questionnaire3', q.id)?.touched
                          ) {
                          <mat-error> This field is required </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire3', q.id)
                          ?.get('attachment')
                          ?.hasError('uploadFailed')
                          ) {
                          <mat-error> File upload failed. Please try again. </mat-error>
                          }
                        </div>
                      </div>

                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment" [disabled]="hasAttachment('questionnaire3', q.id)">
                          No Attachment
                        </mat-checkbox>
                      </div>

                      @if (
                      getQuestionGroup('questionnaire3', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason" maxlength="1000"
                            placeholder="Enter reason"></textarea>
                          @if (
                          getQuestionGroup('questionnaire3', q.id)?.get(
                          'noAttachmentReason'
                          )?.touched || showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (workflowStatus === 'RETURNED') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes (<span class="font-bold">To be updated by
                          Adviser</span> - If any)</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <div class="form-actions mt-4 text-end">
            @if (
            this.questionnaire3FormValid() === 'In Progress' ||
            this.questionnaire3FormValid() === 'Not Started'
            ) {
            <button class="save-btn" (click)="saveAndContinue('questionnaire3')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>
        </mat-expansion-panel>

        <!-- Tier 2 and Tier 3 Supervisor attestation -->
        @if (loggedInRole !== 'Advisor') {
        <mat-expansion-panel formGroupName="questionnaire4" [expanded]="this.currentStep === 5">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(5)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon"> supervisor_account </mat-icon>

              Tier 2 and Tier 3 Supervisor attestation
            </mat-panel-title>
            @if (this.questionnaire4FormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.questionnaire4FormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            }@else if (this.questionnaire4FormValid() === 'Verified') {
            <span class="status-badge verified m-4">
              <mat-icon>verified_user</mat-icon>
              Verified
            </span>
            }@else if (this.questionnaire4FormValid() === 'Action Required') {
            <span class="status-badge actionrequired m-4">
              <mat-icon>pending_actions</mat-icon>
              Action Required
            </span>
            }
            @else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>

          <div class="check-list">
            <ol class="custom-list">
              @for (q of questionnaire4Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire4', q.id)?.get('isVerified')?.value}">
                <div class="row">
                  <!-- QUESTION -->
                  <div class="col-sm-10">
                    <span>
                      {{ q.question }}
                    </span>
                    @if (getQuestionGroup('questionnaire4', q.id)?.get('isVerified')?.value === false &&
                    this.workflowStatus == 'RETURNED') {
                    <p class="delta-badge">
                      <mat-icon class="delta-icon">pending_actions</mat-icon> Action Required
                    </p>
                    }
                  </div>

                  <!-- YES / NO -->
                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>

                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- CONDITIONAL -->
                  @if (getQuestionGroup('questionnaire4', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3">
                    <mat-label>
                      {{ q.inputLabel }}
                    </mat-label>
                    <div class="row">
                      <!-- ENTITY -->
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" maxlength="1000" placeholder="Enter text here" />
                          @if (
                          (getQuestionGroup('questionnaire4', q.id)
                          ?.get('entityCount')
                          ?.hasError('required') &&
                          getQuestionGroup('questionnaire4', q.id)?.get('entityCount')
                          ?.touched) ||
                          showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>

                      <!-- ATTACHMENT -->
                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box" [class.disabled-upload]="
                                    getQuestionGroup('questionnaire4', q.id)?.get('attachment')
                                      ?.disabled
                                  ">
                            <!-- EMPTY -->
                            @if (
                            !getQuestionGroup('questionnaire4', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput [disabled]="
                                          getQuestionGroup('questionnaire4', q.id)?.get(
                                            'noAttachment'
                                          )?.value
                                        " (change)="onFileChange($event, 'questionnaire4', q.id)" />

                              <span> Choose file </span>
                            </label>
                            }

                            <!-- FILE SELECTED -->
                            @if (
                            getQuestionGroup('questionnaire4', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>

                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire4', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>

                              <!-- REMOVE -->

                              @if (
                              ['RETURNED','IN_PROGRESS', 'NOT_STARTED'].includes(workflowStatus) &&
                              !getQuestionGroup('questionnaire4', q.id)?.get('attachment')
                              ?.disabled
                              ) {
                              <button mat-icon-button type="button" class="remove-btn" color="warn"
                                (click)="removeFile('questionnaire4', q.id)">
                                <mat-icon> close </mat-icon>
                              </button>
                              }
                            </div>
                            }
                          </div>
                          @if (
                          getQuestionGroup('questionnaire4', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileType')
                          ) {
                          <mat-error> Only PDF, JPEG and PNG files are allowed. </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire4', q.id)
                          ?.get('attachment')
                          ?.hasError('invalidFileSize')
                          ) {
                          <mat-error> Maximum file size allowed is 5 MB. </mat-error>
                          }
                          @if (
                          getQuestionGroup('questionnaire4', q.id)?.hasError(
                          'attachmentMissing'
                          ) &&
                          !getQuestionGroup('questionnaire4', q.id)?.get('noAttachment')
                          ?.value &&
                          getQuestionGroup('questionnaire4', q.id)?.touched
                          ) {
                          <mat-error> This field is required </mat-error>
                          }

                          @if (
                          getQuestionGroup('questionnaire4', q.id)
                          ?.get('attachment')
                          ?.hasError('uploadFailed')
                          ) {
                          <mat-error> File upload failed. Please try again. </mat-error>
                          }
                        </div>
                      </div>

                      <!-- NO ATTACHMENT -->
                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment" [disabled]="hasAttachment('questionnaire4', q.id)">
                          No Attachment
                        </mat-checkbox>
                      </div>

                      <!-- REASON -->
                      @if (
                      getQuestionGroup('questionnaire4', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason" maxlength="1000" placeholder="Enter reason">
                                  </textarea>
                          @if (
                          getQuestionGroup('questionnaire4', q.id)?.get(
                          'noAttachmentReason'
                          )?.touched || showValidationErrors
                          ) {
                          <mat-error> This field is required. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }
                  @if (workflowStatus === 'RETURNED') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes (<span class="font-bold">To be updated by
                          Adviser</span> - If any)</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <div class="form-actions mt-4 text-end">
            @if (
            this.questionnaire4FormValid() === 'In Progress' ||
            this.questionnaire4FormValid() === 'Not Started'
            ) {
            <button class="save-btn" (click)="saveAndContinue('questionnaire4')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>
        </mat-expansion-panel>
        }

        <!-- Miscellaneous -->
        <mat-expansion-panel formGroupName="miscellaneous" [expanded]="this.currentStep === 6">
          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(6)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">info</mat-icon>
              Miscellaneous
            </mat-panel-title>
            @if (this.miscellaneousFormValid() === 'Completed') {
            <span class="status-badge completed m-4"> ✔ Completed </span>
            } @else if (this.miscellaneousFormValid() === 'In Progress') {
            <span class="status-badge inprogress m-4"> ⏳ In Progress </span>
            } @else {
            <span class="status-badge notstarted m-4">
              <mat-icon>play_arrow</mat-icon>
              Not Started
            </span>
            }
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <mat-label class="field-label">Any other information that you wish to declare?</mat-label>
              <mat-form-field class="w-100">
                <textarea matInput rows="4" formControlName="additionalInfo" placeholder="Enter text here"></textarea>
                <mat-error v-if="entityForm.get('entityCount')?.hasError('required')">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          @if (readonly() === false) {
          <!-- Form Actions -->
          <div class="form-actions mt-4 text-end">
            <!-- [disabled]="formGroup.invalid" -->
            @if (
            this.miscellaneousFormValid() === 'In Progress' ||
            this.miscellaneousFormValid() === 'Not Started'
            ) {
            <button class="save-btn" (click)="saveAndContinue('miscellaneous')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </form>

    <div class="form-actions mt-4">
      @if (
      workflowStatus !== 'SUBMITTED' &&
      workflowStatus !== 'APPROVED' &&
      workflowStatus !== 'IN_REVIEW'
      ) {
      <button color="primary" class="save-btn" (click)="submitForm()">
        <span>Submit</span>
        <mat-icon>arrow_forward</mat-icon>
      </button>
      }
    </div>
  </div>
</app-pias-layout>